import { useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import LogoNRCS from "../../assets/images/LogoNRCS.png";

function MobileApp() {
  const androidUrl =
    "https://play.google.com/store/apps/details?id=com.nrcs.cbts.btsm.app&pcampaignid=web_share";
  const iosUrl = "https://apps.apple.com/us/app/nrcs-bts/id6758692665";

  // Auto-redirect mobile users to their respective store
  useEffect(() => {
    if (isAndroid) {
      window.location.replace(androidUrl);
    } else if (isIOS) {
      window.location.replace(iosUrl);
    }
  }, []);

  // Fallback UI for desktop / undetected devices

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left Side - Branding (fixed on md+) */}
      <div className="hidden md:flex md:w-1/2 h-screen fixed left-0 top-0 bg-gradient-to-br from-pink-50 to-white z-10">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5 pointer-events-none">
          <div className="absolute top-20 left-20 w-8 h-8 bg-pink-400 rounded-lg transform rotate-45"></div>
          <div className="absolute top-40 right-32 w-6 h-6 bg-pink-300 rounded-lg transform rotate-45"></div>
          <div className="absolute bottom-32 left-32 w-10 h-10 bg-pink-500 rounded-lg transform rotate-45"></div>
          <div className="absolute bottom-20 right-20 w-4 h-4 bg-pink-400 rounded-lg transform rotate-45"></div>
        </div>
        {/* Centered Content */}
        <div className="relative z-10 flex flex-col justify-center items-center w-full h-full text-center">
          <div className="mb-6 flex items-center justify-center">
            <img
              src={LogoNRCS}
              alt="BTSM Logo"
              className="h-16 md:h-24 w-auto"
            />
          </div>
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 tracking-tight">
              Blood Transfusion Service Management
            </h3>
          </div>
        </div>
      </div>

      {/* Right Side - App Download */}
      <div className="flex-1 flex items-center justify-center bg-white px-4 py-8 sm:px-6 md:px-8 md:py-12 min-h-screen md:ml-auto md:pl-[50vw] md:relative overflow-y-auto h-screen">
        <div className="w-full max-w-sm sm:max-w-md md:max-w-md">
          {/* Mobile logo (visible on small screens) */}
          <div className="flex justify-center mb-6 md:hidden">
            <img src={LogoNRCS} alt="BTSM Logo" className="h-16 w-auto" />
          </div>

          {/* Header */}
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
              Get the Mobile App
            </h2>
            <p className="text-gray-600 text-sm md:text-base">
              Download the BTSM app on your device
            </p>
          </div>

          {/* App Store Buttons */}
          <div className="flex flex-row gap-3 flex-wrap justify-center">
            {/* Android */}
            <a
              href={androidUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-4 py-2.5 rounded-xl hover:bg-gray-800 transition-colors w-fit"
            >
              <img
                src="/playstore.png"
                alt="Google Play"
                className="h-6 w-6 object-contain flex-shrink-0"
              />
              <div className="text-left">
                <div className="text-xs text-gray-300 leading-none">
                  GET IT ON
                </div>
                <div className="text-base font-semibold leading-tight">
                  Google Play
                </div>
              </div>
            </a>

            {/* iOS */}
            <a
              href={iosUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-4 py-2.5 rounded-xl hover:bg-gray-800 transition-colors w-fit"
            >
              <svg
                viewBox="0 0 24 24"
                className="h-6 w-6 fill-white flex-shrink-0"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <div className="text-left">
                <div className="text-xs text-gray-300 leading-none">
                  Download on the
                </div>
                <div className="text-base font-semibold leading-tight">
                  App Store
                </div>
              </div>
            </a>
          </div>

          {/* Footer */}
          <div className="text-center mt-10">
            <p className="text-xs text-gray-500">
              © NRCS. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileApp;
